import { useTranslation } from "react-i18next";
import DownloadIcon from "~/common/mui/icons/Download";
import { Button, Stack } from "~/common/mui";
import { ReportType } from "~/features/cart/cart/components/Buttons/DownloadReportButton/api/downloadCartReport";

interface DownloadReportButtonsProps {
  label: string;
  onDownload: (type: ReportType) => void;
  disabled: boolean;
  testIdPrefix: string;
}

export const DownloadReportButtons = ({
  onDownload,
  disabled,
}: DownloadReportButtonsProps) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Button
        variant="text"
        startIcon={<DownloadIcon />}
        onClick={() => onDownload(ReportType.XLSX)}
        disabled={disabled}
      >
        {t("downloadExcel.text")}
      </Button>
    </Stack>
  );
};
